import { render, staticRenderFns } from "./PracticeOverview.vue?vue&type=template&id=57dded8e"
import script from "./PracticeOverview.vue?vue&type=script&lang=js"
export * from "./PracticeOverview.vue?vue&type=script&lang=js"
import style0 from "./PracticeOverview.vue?vue&type=style&index=0&id=57dded8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports